let host = `http://${location.host}`

if (process.env.VUE_APP_API_BASE_URL) {
  host = process.env.VUE_APP_API_BASE_URL
} else if (location.host.includes('portalacc.') || location.host.includes('localhost')) {
  host = 'https://dashboardacc.tracefy.io'
} else if (location.host.includes('portal.')) {
  host = 'https://portal-api.tracefy.net'
}

export default {
  baseUrl: host,
  url: `${host}/api/v1/`
}
